/**
 * RESPONSIBILITY: one photograph for the home page's side-by-side scenes.
 *
 * A LIST OF ITS OWN, NOT THE FULL-WIDTH ONE. A photograph made to fill the band is wide and
 * is cropped when squeezed into a frame beside another; one made for a frame is shown
 * whole. So pairs and groups take their own pictures, all one shape (3 : 2), and are drawn
 * exactly as uploaded - no cropping, no reuse of the full-width ones.
 */
import { Row, Img } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';

@Row()
export class HeroGroupPicture {
  @Img({
    label: 'Picture', folder: 'home', maxSizeMb: 12, size: '1200 × 800',
    description: 'Shown beside one or two others, whole and uncropped. Use the size given (3 : 2).',
  })
  image!: ImageValue;
}
